var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 2.27273H21.25V0H18.75V2.27273H6.25V0H3.75V2.27273H2.5C1.125 2.27273 0 3.29545 0 4.54545V22.7273C0 23.9773 1.125 25 2.5 25H22.5C23.875 25 25 23.9773 25 22.7273V4.54545C25 3.29545 23.875 2.27273 22.5 2.27273ZM22.5 22.7273H2.5V7.95455H22.5V22.7273Z",
    fill: "#EBEBEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarReportIcon);
export default __webpack_public_path__ + "static/media/CalendarReportIcon.10e4f92291121cce0cb1ba370c63a7a9.svg";
export { ForwardRef as ReactComponent };